<template>
	<div>
		<template>
			<p>
				<countdown
					key="annual-sale-2020-countdown"
					:time="countdownTime"
					:class="countdownSize"
					:transform="addLeadingZero"
					class="annual-sales"
				>
					<template slot-scope="{ hours, minutes, seconds }">
						<p class="annual-sales__time">
							{{ hours }}
							<span class="annual-sales__time__description">hours</span>
						</p>
						<span class="annual-sales__separator">:</span>
						<p class="annual-sales__time">
							{{ minutes }}
							<span class="annual-sales__time__description">minutes</span>
						</p>
						<span class="annual-sales__separator">:</span>
						<p class="annual-sales__time">
							{{ seconds }}
							<span class="annual-sales__time__description">seconds</span>
						</p>
					</template>
				</countdown>
				<slot />
			</p>
		</template>
	</div>
</template>

<script>
import Countdown from "@chenfengyuan/vue-countdown";

export default {
	name: "AnnualSale2020Countdown",
	components: {
		Countdown
	},
	props: {
		countdownSize: {
			type: String,
			default: "small"
		},
		currentPhase: {
			type: [String, Number],
			default: 0
		},
		phases: {
			type: [Object, Array],
			default() {
				return [];
			}
		},
		timeZone: {
			type: String,
			default: "America/Los_Angeles"
		}
	},
	computed: {
		countdownTime() {
			if (this.phase < 0) {
				return 0;
			}
			const currentPhase = this.phases[this.currentPhase];
			const currentDate = moment().tz(this.timeZone).valueOf();
			const countdownDate = moment.tz(currentPhase.to, "YYYY-MM-DD HH:mm:ss", this.timeZone).valueOf();
			return countdownDate - currentDate;
		}
	},
	methods: {
		addLeadingZero(props) {
			const daysInHours = parseInt(props.days) * 24;
			props.hours += daysInHours;

			Object.entries(props).forEach(([unit, value]) => {
				props[unit] = value < 10 ? `0${value}` : value;
			});

			return props;
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";
.annual-sales {
	color: $white;
	display: flex;
	justify-content: center;
	.annual-sales__time {
		display: flex;
		flex-direction: column;
		.annual-sales__time__description {
			color: $white;
			font-family: Akkurat-Light;
			font-weight: 300;
			text-transform: uppercase;
			text-align: center;
		}
	}
}
.annual-sales.big {
	font-size: 164px;
	letter-spacing: 10.25px;
	margin-bottom: 30px;
	@media screen and (max-width: 766px) {
		margin-bottom: 5px;
	}
	@media screen and (min-width: 767px) and (max-width: 991px) {
		font-size: 134px
	}
	.annual-sales__separator {
		margin-left: 10px;
		margin-right: 15px;
	}
	.annual-sales__time {
		.annual-sales__time__description {
			font-size: 24px;
			letter-spacing: 1.13px;
			margin-left: 0;
			margin-right: 0;
			margin-top: -50px;
		}
	}
	@media screen and (max-width: 766px) {
		& {
			font-size: 56px;
			letter-spacing: 3.5px;
			.annual-sales__separator {
				margin-left: 3px;
				margin-right: 5px;
			}
			.annual-sales__time {
				.annual-sales__time__description {
					font-size: 12px;
					letter-spacing: 0.56px;
					margin-left: 0;
					margin-right: 0;
					margin-top: -18px;
				}
			}
		}
	}
}
.annual-sales.small {
	font-size: 56px;
	letter-spacing: 3.5px;
	.annual-sales__separator {
		margin-left: 3px;
		margin-right: 5px;
	}
	.annual-sales__time {
		.annual-sales__time__description {
			font-size: 12px;
			letter-spacing: 0.56px;
			margin-left: 0;
			margin-right: 0;
			margin-top: -14px;
		}
	}
}
.annual-sales.extra-small {
	font-size: 20px;
	letter-spacing: 3.5px;
	align-items: center;
	.annual-sales__separator {
		margin-left: 3px;
		margin-right: 5px;
	}
	.annual-sales__time {
		font-size: 20px;
		margin: 0;
		.annual-sales__time__description {
		display: none;
		}
	}
	@media (max-width: 768px){
		justify-content: flex-end;
	}
}
.annual-sale-2-countdown {
	margin: 0;
	color: white;
	&__highlight {
		color: #F55AF5;
		font-weight: bold;
	}
}
</style>